import { createApp } from 'vue'
// import 'default-passive-events'

import 'normalize.css'
import './assets/styles/index.less'

import App from './App.vue'
import router from './router'
import store from './store'

// 注册 icons
import 'virtual:svg-icons-register'
// 额外引入图标库
import ArcoVueIcon from '@arco-design/web-vue/es/icon'

// 全局组件
import SvgIcon from '@/components/icon/svg-icon/svg-icon.vue'
// import { loadDirectives } from '@/directives'

import { setupDirectives } from './directives'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ArcoVueIcon)
setupDirectives(app)
// loadDirectives(app)
app.component('svg-icon', SvgIcon)
app.mount('#app')
